import { createApiRef } from '@backstage/core-plugin-api';
import { EnvironmentVariableRoot, EnvironmentVariableSingleObject } from './dto/response/environmentvariable';
import { CreateEnvironmentVariable, UpdateEnvironmentVariable } from './dto/request/environmentvariable';
import { ConfigFile } from './dto/response/configfile';
import { CreateConfigFile, UpdateConfigFile } from './dto/request/configfile';
 
export interface EnvManagerApi {
    listEnvironmentVariables: (environment: string, system_name: string, application_name: string) => Promise<EnvironmentVariableRoot>;
    createEnvironmentVariable: (environment: string, system_name: string, application_name: string,  environment_variable: CreateEnvironmentVariable) => Promise<EnvironmentVariableSingleObject>;
    updateEnvironmentVariable: (environment: string, system_name: string, application_name: string, key: string, environment_variable: UpdateEnvironmentVariable)=> Promise<EnvironmentVariableSingleObject>
    deleteEnvironmentVariable: (environment: string, system_name: string, application_name: string, key: string)=> Promise<boolean>;

    getConfigFile: (environment: string, system_name: string, application_name: string) => Promise<ConfigFile>;
    createConfigFile: (environment: string, system_name: string, application_name: string,  config_file: CreateConfigFile) => Promise<ConfigFile>;
    updateConfigFile: (environment: string, system_name: string, application_name: string, config_file: UpdateConfigFile)=> Promise<ConfigFile>
    deleteConfigFile: (environment: string, system_name: string, application_name: string)=> Promise<boolean>;
}
 
export const EnvManagerApiRef = createApiRef<EnvManagerApi>({
    id: 'plugin.env-manager-api.service'
})